







import { Component, Vue } from 'vue-property-decorator';
import AgoraDeviceTest from "@share/common/agora-device-test/AgoraDeviceTest.vue"

@Component({
    name: 'DeviceTestPart',
    components: { AgoraDeviceTest }
})
export default class DeviceTestPart extends Vue {

}
